import React, {Dispatch, ReactElement, useEffect} from 'react';

import {PaginatedListProps} from './PaginatedList';

interface PaginatedPageProps<P, D> extends PaginatedListProps<P, D> {
  page: number;
  setHasNext: Dispatch<React.SetStateAction<undefined | null | string>>;
  setIsLoading: (page: number, isLoading: boolean) => unknown;
  removePage: (page: number) => unknown;
}

export const PaginatedPage = <P, D>({
  hook,
  page,
  params,
  render,
  setHasNext,
  setIsLoading,
  removePage,
}: PaginatedPageProps<P, D>): ReactElement => {
  const {data, isError, isLoading} = hook({...params, page});

  useEffect(() => {
    if (data) {
      setHasNext(data?.next);
    }
  }, [data]);

  useEffect(() => {
    if (isError) {
      removePage(page);
    }
  }, [isError]);

  useEffect(() => {
    setIsLoading(page, isLoading);
  }, [isLoading]);

  return render(data);
};
